export default "__VITE_ASSET__0DWEZRFl__"